import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

export const TRADE_ATTACHMENTS_QUERY_KEY = ["trades", "attachments"] as const;

export function tradeAttachmentsQueryKey(tradeId: string) {
  return [...TRADE_ATTACHMENTS_QUERY_KEY, tradeId] as const;
}

export function useTradeAttachments(tradeId: string) {
  const client = useApiClient();
  return useQuery({
    queryKey: tradeAttachmentsQueryKey(tradeId),
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/trades/{trade_id}/attachments",
        { params: { path: { trade_id: tradeId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to list attachments for trade ${tradeId}`);
      }
      return data;
    },
    enabled: tradeId.length > 0,
  });
}
